module.exports = __webpack_public_path__ + "static/img/login_06.4dd4f43.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/login/login_06.png
// module id = /YIG
// module chunks = 1